import Popper from 'element-ui/lib/utils/vue-popper'
import merge from 'element-ui/lib/utils/merge'

export const NewPopper = {
  props: {
    appendToBody: Popper.props.appendToBody,
    offset: Popper.props.offset,
    boundariesPadding: Popper.props.boundariesPadding,
    arrowOffset: Popper.props.arrowOffset,
    transformOrigin: Popper.props.transformOrigin
  },
  methods: Popper.methods,
  data() {
    return merge({ visibleArrow: true }, Popper.data)
  },
  beforeDestroy: Popper.beforeDestroy
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker2/src/mixins/popper.js